export default {"src":"/_next/static/media/boxed.a3345ea7.svg","height":30,"width":888,"blurWidth":0,"blurHeight":0};